import { Tag, TTagVariant } from '@ui';
import React from 'react';
import { TClientPairingStatus } from 'types/client.types';

const STATUS_MAP: Record<TClientPairingStatus, TTagVariant> = {
  pending: 'info',
  paired: 'success',
  rejected: 'danger',
  invited: 'warning',
};

const TEXT_MAP: Record<TClientPairingStatus, string> = {
  pending: 'Čakajúci na schválenie',
  rejected: 'Odmietnutý',
  paired: 'Prijatý',
  invited: 'Pozvaný',
};

interface ClientStatusTagProps {
  status?: TClientPairingStatus;
}

const ClientStatusTag: React.FunctionComponent<ClientStatusTagProps> = ({ status }) => {
  if (!status) {
    return null;
  }

  return (
    <Tag size="large" variant={STATUS_MAP[status]}>
      {TEXT_MAP[status]}
    </Tag>
  );
};

export default ClientStatusTag;
